'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './suite-directory.routes';

export class SuiteDirectoryComponent {
  constructor(IntegrationService, DTOptionsBuilder, $state, $stateParams, Config, SettingsService) {
    'ngInject';
    this.baseContainerClass = Config.getPlatformConfig().getBaseContainerClass();
    this.IntegrationService = IntegrationService;

    this.data = [];
    this.type = $stateParams.type;

    SettingsService.getByName({name: 'suite-directory-config'}, setting => {

      this.config = setting.data[this.type];

      this.pageTitle = this.config.title || Config.getPageTitleByStateWithDefault($state.current.name, "Suite Directory");

      this.dtOptions = DTOptionsBuilder.newOptions()
        .withOption('dom', 'lBfrtip')
        .withOption('responsive', true)
        .withOption('order', [0, 'asc'])
        .withOption('buttons',[{
          extend: 'excel',
          title: this.pageTitle
        },{
          extend: 'csv',
          title: this.pageTitle
        },{
          title: this.pageTitle,
          message: 'As of ' + moment().format("MMMM Do YYYY"),
          extend: 'pdf',
          orientation: 'landscape',
          pageSize: 'LETTER'
        },'print']);

      this.IntegrationService.querySuiteLDAP({
        base: btoa(this.config.query.base),
        filter: btoa(this.config.query.filter)
      }, data => {
        this.data = data.map(entry => {
          if (entry.json && typeof entry.json == "string")
            entry.json = JSON.parse(entry.json);
          return entry;
        });
      });
    });
  }

  getAddress(contact, type) {
    if (!contact || !contact.address || !contact.address.length)
      return "-";

    let address = contact.address.find(adr => adr.isPrimary) || contact.address[0] || {};

    if (type) {
      address = contact.address.find(adr => adr.type == type);
    }

    if (!address)
      return "-";

    let adrString = [];

    adrString.push(address.street);
    if (address.street2)
      adrString.push(address.street2);
    adrString.push(address.city + ' ' + address.state + ', ' + address.zip);
    if (address.country)
      adrString.push(address.country);

    return adrString.join(', ');
  }

  getEmail(contact, type) {
    if (!contact || !contact.email || !contact.email.length)
      return "-";

    let email = contact.email.find(email => email.isPrimary) || contact.email[0] || {address:'-'};

    if (type) {
      email = contact.email.find(email => email.type == type);
      if (!email)
        return "-";
    }

    return email.address;
  }

  getPhone(contact, type) {
    if (!contact || !contact.phone || !contact.phone.length)
      return "-";

    let phone = contact.phone.find(phone => phone.isPrimary) || contact.phone[0] || {number:'-'};

    if (type) {
      phone = contact.phone.find(phone => phone.type == type);
      if (!phone)
        return "-";
    }

    return phone.number;
  }
}

export default angular.module('conduuApp.suiteDirectory', [uiRouter])
  .config(routes)
  .component('suiteDirectory', {
    template: require('./suite-directory.html'),
    controller: SuiteDirectoryComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/directories/suite/suite-directory.component.js